import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogTitle, Divider, Typography } from '@dls/react-core';
import { StyledBlueHeading } from '../styled/styles';
import { DeviceForm } from '../devices/device-form';
import { Devices, updateDevice } from '../../api/studykit';
import { StudyPageContext } from '../../App';
import { useSnackbar } from 'notistack';
import { KeyedMutator } from 'swr/dist/types';
import { NotiStackAction } from '../styled/notistack-action';
import { AsyncSubmitHandler } from '../../helpers/form-error-handling';

interface EditSubjectDeviceDialogProps {
  open: boolean;
  onClose: () => void;
  device: Devices;
  subjectId: string;
  mutate: KeyedMutator<any>;
}

export const EditSubjectDeviceDialog: React.FC<EditSubjectDeviceDialogProps> = ({
  open,
  onClose,
  device,
  subjectId,
  mutate,
}) => {
  const { study } = useContext(StudyPageContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit: AsyncSubmitHandler<Devices> = (data) => {
    return updateDevice(study.id, subjectId, device.id, data)
      .then(() => mutate())
      .then(() => {
        enqueueSnackbar(`${data.name} successfully updated!`, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      })
      .then(() => onClose());
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle disableTypography style={{ display: `flex`, alignItems: `center` }}>
        <StyledBlueHeading variant={'h3'}>{device.type}</StyledBlueHeading>
        <Typography style={{ marginLeft: `2.25em` }}>
          Last Sync : {device.lastSync ? device.lastSync : 'N/A'}
        </Typography>
      </DialogTitle>
      <Divider style={{ marginTop: `8px` }} orientation={'horizontal'} />
      <DialogContent>
        <DeviceForm onSubmit={onSubmit} onCancel={onClose} device={device} />
      </DialogContent>
    </Dialog>
  );
};
